export default __webpack_public_path__ + "static/card-visa-platinum@3x-ac92c4136d3d4da01ed4ec1e9982aca6.png";